// Of een aan/uit-vlag aanstaat, ongeacht de vorm waarin hij is opgeslagen.
//
// WAAROM DIT NIET `=== 'true'` IS. Deze vlaggen staan in productie in meerdere
// vormen tegelijk, omdat er meerdere schrijvers zijn:
//
//   - `ToggleButton` schrijft altijd de TEKST 'true' / 'false'
//   - onboarding, de Stripe-webhook en `createProjectAccount` schrijven echte
//     BOOLEANS
//   - sommige velden krijgen bij het aanmaken een derde vorm mee: elk nieuw
//     onderzoek start met `SendCopyOption: 'off'` (`Research.jsx`)
//
// Gemeten 2026-08-28: `Research.SendCopyOption` bevat 178× 'off', 14× 'on',
// 2× 'true' en 2× 'false'. Die 14 met 'on' werden door een `=== 'true'`-lezer
// als UIT gelezen — veertien onderzoeken waarvan de respondenten nooit de optie
// kregen om een kopie van hun antwoorden te ontvangen.
//
// FAALT DICHT. Alles wat we niet herkennen betekent 'uit'. Een vlag ten onrechte
// als aan lezen zet functionaliteit open die iemand bewust uit had staan.
//
// De backend heeft zijn eigen tweelingen: `functions/utils/isModuleOn.js` voor
// één `CompagnyMeta`-doc en `functions/utils/compagnyIdsWithModule.js` voor de
// vraag over alle omgevingen.
//
// AI-CONTEXT: See docs/pitfalls.md#ui-togglebutton-string-only-branches

/** De teksten die 'aan' betekenen. Kleine letters, zonder omringende witruimte. */
const ON_WORDS = ['true', 'on', 'yes', '1']

/**
 * @param {*} value - De ruwe waarde uit Firestore
 * @returns {boolean}
 */
const isFlagOn = (value) => {
    if (value === true) return true
    if (typeof value === 'number') return value === 1
    if (typeof value !== 'string') return false
    return ON_WORDS.includes(value.trim().toLowerCase())
}

/** De teksten die 'uit' betekenen. */
const OFF_WORDS = ['false', 'off', 'no', '0']

/**
 * Of een vlag NADRUKKELIJK op uit staat.
 *
 * Dit is niet `!isFlagOn(value)`. Een ontbrekende waarde is niet hetzelfde als
 * uit: bij velden waar 'niets ingevuld' zichtbaar of aan betekent — zoals
 * `ReportLayoutItems.Visibility`, waar 319 van de 320 documenten geen waarde
 * hebben — zou dat alles verbergen.
 *
 * Gebruik dit voor de vraag "moet ik dit verbergen?", en `isFlagOn` voor
 * "moet ik dit aanzetten?".
 *
 * @param {*} value - De ruwe waarde uit Firestore
 * @returns {boolean}
 */
const isFlagOff = (value) => {
    if (value === false) return true
    if (typeof value === 'number') return value === 0
    if (typeof value !== 'string') return false
    return OFF_WORDS.includes(value.trim().toLowerCase())
}

export default isFlagOn
export { isFlagOff, ON_WORDS, OFF_WORDS }
